export default "__VITE_ASSET__N05vlXOT__"